let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lIgXL")).then(() => parcelRequire('aOmEt'));